import { render, staticRenderFns } from "./loaderComponent.vue?vue&type=template&id=13a8616c"
import script from "./loaderComponent.vue?vue&type=script&lang=js"
export * from "./loaderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13a8616c')) {
      api.createRecord('13a8616c', component.options)
    } else {
      api.reload('13a8616c', component.options)
    }
    module.hot.accept("./loaderComponent.vue?vue&type=template&id=13a8616c", function () {
      api.rerender('13a8616c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loaderComponent.vue"
export default component.exports